<script setup lang="ts">
import { T } from '@tolgee/vue'
import { computed } from 'vue'
import CrossCircleIcon from '@/components/icons/CrossCircleIcon.vue'
import { useWatchOverlays } from '@/composables/helpers/scoll'
import { useFullScreenDimensions } from '@/composables/helpers/fullscreen'

const props = defineProps<{
  show: boolean
  spinCount: number
  description: string
}>()

const { topStyle } = useFullScreenDimensions()

useWatchOverlays(computed(() => props.show))

</script>
<template>
  <Transition
    name="fade"
    mode="out-in"
  >
    <div
      v-if="show"
      class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 bg-dark-most-bottom-layer/[.95] flex flex-col z-[800]"
    >
      <CrossCircleIcon
        class="w-6 h-6 min-w-[24px] absolute top-3 right-3 text-white/[87%]"
        :style="topStyle"
      />
      <div class="h-full w-full flex-1 flex flex-col items-center justify-center relative">
        <div
          class="absolute w-[364px] h-[364px] rounded-full bg-green-primary/[.54] blur-[43px] -z-[1]"
        />
        <h1 class="text-white text-[36px] font-bold leading-[42px] text-center max-w-[315px] mb-3">
          <T
            key-name="fortune_wheel.extra_spin.title"
            default-value="Congrats, you got {count, plural, one {# extra spin} other {# extra spins}}!"
            :params="{count: spinCount}"
          />
        </h1>
        <p
          class="text-base text-center text-light-white font-medium max-w-[315px] -tracking-[0.32px] mb-6"
        >
          {{ description }}
        </p>
        <img
          src="@/assets/images/gifs/duck-sunglasses.gif"
          class="size-[212px]"
        >
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
  opacity: 0;
}
</style>